import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
import { changeDirection, fmtChange, fmtChangeFixed, fmtPts } from '../utils/formatters';

/**
 * A change versus before: arrow + sign + meaning colour, never colour alone.
 * `size="sm"` sits in a text-sm table cell or card line; the default is the
 * KPI change line. (A text-size class passed through className cannot win:
 * the production CSS orders .text-sm before .text-xs.)
 * `good="down"` is for a cost: a rise keeps its arrow and sign but takes the
 * bad colour. `good="neither"` keeps arrow and sign in the neutral colour —
 * for a change that only mirrors another number (a fully estimated cost).
 * `fixed` keeps one decimal always, for a column of changes (+14.0%).
 */
export default function Change({ value, unit = '%', size = 'xs', good = 'up', fixed = false, className = '' }: { value: number; unit?: '%' | 'pts'; size?: 'xs' | 'sm'; good?: 'up' | 'down' | 'neither'; fixed?: boolean; className?: string }) {
  const dir = changeDirection(value);
  const color = dir === 'flat' || good === 'neither' ? 'text-[#6B6670]' : dir === good ? 'text-[#2E6B4F]' : 'text-[#B54A4A]';
  const Icon = dir === 'down' ? TrendingDown : TrendingUp;
  return (
    <span className={`inline-flex items-center gap-1 font-sans ${size === 'sm' ? 'text-sm' : 'text-xs'} font-medium tabular-nums ${color} ${className}`}>
      {dir !== 'flat' && <Icon size={14} strokeWidth={1.75} aria-hidden="true" />}
      <span className="sr-only">{dir === 'up' ? 'Up ' : dir === 'down' ? 'Down ' : 'No change '}</span>
      {unit === 'pts' ? fmtPts(value) : fixed ? fmtChangeFixed(value) : fmtChange(value)}
    </span>
  );
}
